import { render, staticRenderFns } from "./AutocompletePacientes.vue?vue&type=template&id=fca0d8e6"
import script from "./AutocompletePacientes.vue?vue&type=script&lang=js"
export * from "./AutocompletePacientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports